import React from 'react';
import './banner-carousel.scss';
import { Link } from 'react-router-dom';
import { getActionLink } from 'CPMapping';
import ImageOverlay from '../../common/ImageOverlay/ImageOverlay';
import ImageSwitcher from '../../common/ImageSwitcher/ImageSwitcher';
import AnalyticsService from 'AnalyticsService';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const { clevertap } = AnalyticsService;

const BannerCarousel = ({ banners = [] }) => {
  const showArrows = banners?.length > 1;

  const getBanners = () => {
    const carousels = banners.map(b => {
      return (
        <Link
          to={getActionLink(b)}
          key={`banner-custom-tile-${b.customTileId}`}
          className="desktop-banner-carousel--banner"
          onClick={() => {
            const key = 'Carousel View';
            const payload = {
              source: 'Carousel',
              customTitleID: b?.customTitleID,
              actionType: b?.actionType,
            };
            clevertap.sendCleverTapEvent(key, payload);
          }}
        >
          <ImageOverlay>
            <img src={b.bannerImage} />
          </ImageOverlay>
        </Link>
      );
    });
    return carousels;
  };

  const ArrowGroup = ({ next, previous }) => {
    if (!showArrows) {
      return null;
    }
    return (
      <div className="custom-arrow">
        <ImageSwitcher onNext={() => next()} onPrevious={() => previous()} />
      </div>
    );
  };

  const CustomDot = ({ onClick, active }) => {
    if (!showArrows) {
      return null;
    }
    return (
      <div className="custom-dot-container">
        <div
          onClick={() => onClick()}
          className={active ? 'active-dot' : 'inactive-dot'}
        />
      </div>
    );
  };

  return (
    <React.Fragment>
      <div className="main-carousel-container">
        <Carousel
          additionalTransfrom={0}
          arrows={false}
          autoPlay={showArrows}
          autoPlaySpeed={5000}
          centerMode={false}
          className=""
          customTransition="all .5s linear"
          transitionDuration={500}
          containerClass="container-with-dots"
          draggable={showArrows}
          focusOnSelect={false}
          infinite={showArrows}
          itemClass=""
          keyBoardControl
          minimumTouchDrag={80}
          pauseOnHover={false}
          renderArrowsWhenDisabled={false}
          renderButtonGroupOutside={false}
          renderDotsOutside={false}
          customButtonGroup={<ArrowGroup />}
          showDots={showArrows}
          dotListClass="homepage-banner-indicator"
          customDot={<CustomDot />}
          responsive={{
            desktop: {
              breakpoint: {
                max: 3000,
                min: 1024,
              },
              items: 1,
            },
            mobile: {
              breakpoint: {
                max: 464,
                min: 0,
              },
              items: 1,
            },
            tablet: {
              breakpoint: {
                max: 1024,
                min: 464,
              },
              items: 1,
            },
          }}
          rewind={false}
          rewindWithAnimation={false}
          rtl={false}
          shouldResetAutoplay
          sliderClass=""
          slidesToSlide={1}
        >
          {getBanners()}
        </Carousel>
      </div>
    </React.Fragment>
  );
};

export default BannerCarousel;
